import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { FiltersSearchState } from './filters-search.state';
import type { Observable } from 'rxjs';
import type { FilterSearch } from '../../service/filters-search/models/filters-search.model';
import { UpdateFilterSelection, CancelFilters, RemoveAllFilters, ApplyFilters, GetFilters, ResetStore } from './filters-search.actions';

@Injectable({
  providedIn: 'root',
})
export class FiltersSearchFacade {
  private readonly store = inject(Store);

  @Select(FiltersSearchState.isLoading) isLoading$: Observable<boolean>;
  @Select(FiltersSearchState.filters) filters$: Observable<FilterSearch[]>;
  @Select(FiltersSearchState.filtersBackup) filtersBackup$: Observable<FilterSearch[]>;

  get filters(): FilterSearch[] {
    return this.store.selectSnapshot(FiltersSearchState.filters);
  }

  getFilters() {
    return this.store.dispatch(new GetFilters());
  }

  updateFilterSelection(filterGroup: string, filterItem: string) {
    return this.store.dispatch(new UpdateFilterSelection(filterGroup, filterItem));
  }

  cancelFilters() {
    return this.store.dispatch(new CancelFilters());
  }

  removeAllFilters() {
    return this.store.dispatch(new RemoveAllFilters());
  }

  applyFilters() {
    return this.store.dispatch(new ApplyFilters());
  }

  resetStore() {
    return this.store.dispatch(new ResetStore());
  }
}
